export const USER_ROLES = {
  GUEST: "guest",
  ALUMNE: "alumne",
  PROFESSOR: "professor",
  ADMIN: "admin",
};

function normalizeRoleValue(role) {
  return String(role || "").replace(/^\//, "");
}

export function getUserRoleFromGroups(groups = []) {
  const normalizedGroups = Array.isArray(groups) ? groups.map((group) => `/${normalizeRoleValue(group)}`) : [];

  if (normalizedGroups.includes("/professor")) return USER_ROLES.PROFESSOR;
  if (normalizedGroups.includes("/admin")) return USER_ROLES.ADMIN;
  if (normalizedGroups.includes("/alumne")) return USER_ROLES.ALUMNE;
  return USER_ROLES.GUEST;
}

export function getUserRoleFromKeycloak(keycloak) {
  if (!keycloak?.authenticated) return USER_ROLES.GUEST;
  return getUserRoleFromGroups(keycloak?.tokenParsed?.groups || []);
}

export function getDefaultRouteForRole(role) {
  switch (role) {
    case USER_ROLES.ALUMNE:
      return "/game";
    case USER_ROLES.PROFESSOR:
      return "/applicatiu";
    case USER_ROLES.ADMIN:
      return "/";
    default:
      return "/";
  }
}

export function hasAnyRole(role, allowedRoles = []) {
  if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) return true;
  return allowedRoles.map(normalizeRoleValue).includes(normalizeRoleValue(role));
}

export function canAccessJourney(role) {
  return [USER_ROLES.ALUMNE, USER_ROLES.PROFESSOR, USER_ROLES.ADMIN].includes(role);
}

export function canAccessJourneyEntry(role) {
  return role === USER_ROLES.ALUMNE;
}

export function canAccessClassicSurvey(role) {
  return role === USER_ROLES.PROFESSOR || role === USER_ROLES.ADMIN;
}

export function canAccessTeacherArea(role) {
  return role === USER_ROLES.PROFESSOR || role === USER_ROLES.ADMIN;
}

export function canAccessStudentDashboard(role) {
  return role === USER_ROLES.ALUMNE;
}
